const COST_REPORT_SOURCE = {
  MAIN: 'MAIN',
  SANDBOX: 'SANDBOX',
} as const;

export const COST_REPORT_SOURCE_OPTIONS = {
  [COST_REPORT_SOURCE.MAIN]: 'Main',
  [COST_REPORT_SOURCE.SANDBOX]: 'Sandbox',
} as const;
